import api from "@/api";

import { initCommonSetting, initCommonSettingState } from "./common-setting.inits";
import { CHAT_PROMPT_ALERTS } from "./common-setting.const";

/** @type {import("vuex").Module<import("./common-setting.inits").CommonSettingState>} */
export const setting = {
    namespaced: true,

    state: initCommonSettingState(),

    getters: {
        chatPromptAlerts(state) {
            return Object.values(CHAT_PROMPT_ALERTS).map(({ text, value, title, desc }) => ({
                title,
                value,
                placeholder: text,
                desc,

                text: (state?.data?.chatPromptAlerts || []).find((item) => item.value == value)?.text || null,
            }));
        },
    },

    mutations: {
        setData(state, { setting }) {
            state.data = initCommonSetting(setting);
        },
    },

    actions: {
        async getData({ commit }, { isConsole = false } = {}) {
            const { get } = isConsole ? api.console.setting : api.v1.setting;
            const { setting } = await get();
            commit("setData", { setting });
            return setting;
        },
    },

    modules: {},
};
